module.exports = __webpack_public_path__ + "components/flag/static/square/ag-3fabe840b5d8bcbe0d9389d57085724a.svg";